import createAction from "redux-actions/es/createAction";
import { uiEarlyFeedback as uiEarlyFeedbackApi, getAccessTokenOrdId as api , getPageState as getPageStateApi, checkEmails as checkEmailsApi , talktoAmy as talktoAmyApi , createCustomerName as createCustomerNameApi , getCustomerName as getCustomerNameApi}  from "../api/index";
import { fetchSignIn as customerLoginAction } from "../../login/actions/index";
import { checkAuth as authApi } from "../../upgrade-status/api/index";
import { auth, loadInitClientDataFail } from "../../../actions/authActions";
import { kickOut } from "../../../actions/authActions";
import {fetchScenarioList , updatedSingleRow, getScenarioUpdateRow, fetchUpdatedScenarioList, fetchScenarioSingleRow, getLatestJobId as getLatestJobIdApiCall} from "../../upgrade-status/actions/index"
import {
  getFeatureNames,
  getFeatureSteps,
  fetchJenkinsJobsEngr,
  getAllTestCasesWithDetails
} from "../../execuation-dashboard/actions/index";
import {
  uiEarlyFeedbackStatusJenkinsJob,
  uiEralyFeedBackbuildJenkinsJob,
  fetchJenkinsJobsEngrClear
} from "../../execuation-dashboard/actions/index";
import { fetchTestData as fetchTestDataApi } from "../api/index";

export const customerStatus = createAction("CUSTOMER_TOKEN_ID_START");
export const customerSuccess = createAction("CUSTOMER_TOKEN_ID_SUCCESS");
export const customerUpdate = createAction("CUSTOMER_TOKEN_ID_UPDATE");
// export const customerAddRow = createAction("CUSTOMER_TOKEN_ID_ADD_ROW");
export const customerFail = createAction("CUSTOMER_TOKEN_ID_FAIL");
export const customerClear = createAction("CUSTOMER_TOKEN_ID_CLEAR");

export const getPageSateStart = createAction("CUSTOMER_PAGE_STATE_START");
export const getPageSateSuccess = createAction("CUSTOMER_PAGE_STATE_SUCCESS");
export const getPageSateFail = createAction("CUSTOMER_PAGE_STATE_FAIL");

export const checkEmailsStart = createAction("CHECK_EMAILS_START");
export const checkEmailsSuccess = createAction("CHECK_EMAILS_SUCCESS");
export const updateCustomeDomain = createAction("UPDATE_CUSTOMER_DOMAIN");
export const checkEmailsFail = createAction("CHECK_EMAILS_FAIL");

export const uiEarlyFeedbackStart = createAction("UI_EARLY_FEEDBACK_START");
export const uiEarlyFeedbackSuccess = createAction("UI_EARLY_FEEDBACK_SUCCESS");
export const uiEarlyFeedbackFail = createAction("UI_EARLY_FEEDBACK_FAIL");

export const fetchTokenFail = createAction("FETCH_TOKEN_FAIL");
export const tokenErrorClear = createAction("TOKEN_ERROR_CLEAR");

export const fetchTestDataStart = createAction("FETCH_TEST_DATA_START");
export const fetchTestDataSuccess = createAction("FETCH_TEST_DATA_SUCCESS");
export const fetchTestDataFail = createAction("FETCH_TEST_DATA_FAIL");

export const createCustomerNameStart = createAction("CREATE_CUSTOMER_NAME_START");
export const createCustomerNameSuccess = createAction("CREATE_CUSTOMER_NAME_SUCCESS");
export const createCustomerNameFail = createAction("CREATE_CUSTOMER_NAME_FAIL");

export const getCustomerNameStart = createAction("GET_CUSTOMER_NAME_START");
export const getCustomerNameSuccess = createAction("GET_CUSTOMER_NAME_SUCCESS");
export const getCustomerNameFail = createAction("GET_CUSTOMER_NAME_FAIL");


export const getReportStart = createAction("GET_REPORT_START");
export const getReportSuccess = createAction("GET_REPORT_SUCCESS");
export const getReportFail = createAction("GET_REPORT_FAIL");
export const getReportClear = createAction("GET_REPORT_CLEAR");
// export const getReportUpdate = createAction("GET_REPORT_UPDATE");


export const redirectFromPSStart = createAction("REDIRTECT_PS_START");
export const redirectFromPSSuccess = createAction("REDIRTECT_PS_SUCCESS");
export const redirectFromPSFail = createAction("REDIRTECT_PS_FAIL");

export const  redirectFromPushStatus=  ()=>{
  return async (dispatch)=>{
         dispatch(redirectFromPSSuccess(true)); 
  }

}

export const talktoAmy = (orgId, query) => {
  return async (dispatch) => {
    // dispatch(getReportClear());
    await talktoAmyApi(orgId, query)
      .then((res) => {
        // dispatch(getReportClear());
        if (res?.status === 200) {
          let data = res?.data;
           let dataFromPersistence=Array.from(data?.dataFromPersistence); 
            let listArrayObj =  data?.dataFromPersistence;
            listArrayObj=data?.dataFromPersistence;
            const size = 3;
            const chunks = [];
            while (listArrayObj.length) {
              chunks.push(listArrayObj.splice(0, size));
            }
          data.dataFromPersistence=dataFromPersistence;  
          let responseDataModify=  {...data, ...{modifyArry:chunks}};  
          dispatch(getReportSuccess(responseDataModify));
        }
      })
      .catch((err) => {
        dispatch(getReportFail(err));
      });
  };
};
export const fetchTestData = (orgId, customerName) => {
  return async (dispatch) => {
    await fetchTestDataApi(orgId, customerName)
      .then((res) => {
        if (res?.status === 200) {
          let data = res?.data;
          dispatch(fetchTestDataSuccess(data));
        }
      })
      .catch((err) => {
        dispatch(fetchTestDataFail(err));
      });
  };
};

export const customer = (data) => {
  return async (dispatch) => {
    await api(data)
      .then((res) => {
        if (res?.status === 200) {
          let data = res?.data;
          dispatch(customerSuccess(data));
        }
      })
      .catch((err) => {
        dispatch(customerFail(err.request.status));
      });
  };
};

export const createCustomerName = (data) => {
  return async (dispatch) => {
    // dispatch(createCustomerNameSuccess({'customerName':'hullu', 'orgId':'xyz'}));
    await createCustomerNameApi(data)
      .then((res) => {
        if (res?.status === 200) {
          let data = res?.data;
          dispatch(createCustomerNameSuccess(data));
        }
      })
      .catch((err) => {
        dispatch(createCustomerNameFail(err));
      });
  };
};

export const getCustomerName = (data) => {
  return async (dispatch) => {
    dispatch(createCustomerNameSuccess({}));
    await getCustomerNameApi(data)
      .then((res) => {
        if (res?.status === 200) {
          let data = res?.data;
          dispatch(getCustomerNameSuccess(data));
        }
      })
      .catch((err) => {
        dispatch(getCustomerNameFail(err));
      });
  };
};

export const getPageState = (data) => {
  return async (dispatch) => {
    await getPageStateApi(data)
      .then((res) => {
        if (res?.status === 200) {
          let data = res?.data;
          dispatch(getPageSateSuccess(data));
        }
      })
      .catch((err) => {
        dispatch(getPageSateFail(err));
      });
  };
};

export const checkEmails = (data) => {
  return async (dispatch) => {
    await checkEmailsApi(data)
      .then((res) => {
        if (res?.status === 200) {
          let message = res?.data;
          let resData = {
            emailId: data.emailId,
            status:
              message ===
              "Successfully triggered the welcome email to the customer"
                ? "By clicking on the proceed button, you would be redirected to the test lab, where you can review the tests that would be executed."
                : "",
          };
          dispatch(checkEmailsSuccess(resData));
        }
      })
      .catch((err) => {
        dispatch(checkEmailsFail(err));
      });
  };
};

export const uiEarlyFeedback = (data, token) => {
  return async (dispatch) => {
    await uiEarlyFeedbackApi(data, token)
      .then((res) => {
        if (res?.status === 200) {
          dispatch(uiEarlyFeedbackSuccess(res.data));
        }
      })
      .catch((err) => {
        dispatch(uiEarlyFeedbackFail(err));
      });
  };
};

export const customerLogin = (data) => {
  return async (dispatch) => {
    await dispatch(customerLoginAction(data));
  };
};

export const updateCustomerDomain = (data) => {
  return async (dispatch) => {
    await dispatch(checkEmailsSuccess(data));
  };
};

export const logOutCustomer = () => {
  return (dispatch) => {
    dispatch(kickOut());
  };
};

export const getAuth = (data) => {
  return async (dispatch) => {
    await authApi(data.token)
      .then((res) => {
        if (res.data === "Token is Valid" && res.status === 200) {
          let payload = {
            token: data.token,
            refreshToken: data.token,
            isSignUp: false,
            redirect:data.redirect,
            jobId:data.jobId,
            orgId:data.orgId,
            projectName:data.projectName
          };
          dispatch(auth(payload));
          let obj = {
            projectName: data.projectName,
          };
          // dispatch(fetchScenarioList(obj));
        }
      })
      .catch((err, res) => {
        dispatch(fetchTokenFail("Token is Not Valid"));
        // dispatch(loadInitClientDataFail("unable to login"));
        // window.location.href=window.location.origin+'/error';
      });
  };
};

export const getFeatureNamesCustomer = (data) => {
  return (dispatch) => {
    dispatch(getFeatureNames(data));
  };
};

export const getFeatureStepsCustomer = (idata, id) => {
  return (dispatch) => {
    dispatch(getFeatureSteps(idata, id));
  };
};

export const fetchJenkinsJobsEngrFunCall = (data) => {
  return async (dispatch) => {
    await dispatch(fetchJenkinsJobsEngr(data));
  };
};

export const uiEarlyFeedbackStatusJenkinsJobCall = (data) => {
  return async (dispatch) => {
    await dispatch(uiEarlyFeedbackStatusJenkinsJob(data));
  };
};

export const uiEralyFeedBackbuildJenkinsJobCall =  (data) => {
  return async (dispatch) => {
   await  dispatch(uiEralyFeedBackbuildJenkinsJob(data));
  };
};
export const fetchScenarioListApiCall = (data) => {
  return async (dispatch) => {
    // dispatch(fetchScenarioList(data));
   await dispatch(fetchScenarioSingleRow(data));
  };
};
export const updatedSingleRowApiCall = (data) => {
  return (dispatch) => {
    dispatch(updatedSingleRow(data));
  };
};
export const fetchUpdatedScenarioListApiCalls = (data) => {
  return (dispatch) => {
    dispatch(fetchUpdatedScenarioList(data));
  };
};
export const fetchJenkinsJobsEngrClearApiCalls = () => {
  return (dispatch) => {
    dispatch(fetchJenkinsJobsEngrClear([]));
  };
};
export const getAllTestCasesWithDetailsApiCall = (data) => {
  return (dispatch) => {
    dispatch(getAllTestCasesWithDetails(data));
  };
};
export const getLatestJobIdApiFun = (data) => {
  return async (dispatch) => {
   await  dispatch(getLatestJobIdApiCall(data));
  };
};

// uiEralyFeedBackbuildJenkinsJob
